<template>
  <div>
    <div class="inline-flex pb-6">
      <h1 class="inline-flex pr-4">
        Customs Permit (Manual) Component
        <p class="pl-4">|</p>
      </h1>
      <p class="pr-4"></p>
      <!-- <vs-button
        color="#5b3cc4"
        type="filled"
        icon="cloud_upload"
        @click="upload"
        >Upload</vs-button
      > -->
      <p class="pr-4"></p>
      <vs-button color="#5b3cc4" type="filled" icon="search" @click="grid"
        >List</vs-button
      >
      <p class="pr-4"></p>
      <vs-button color="success" type="filled" icon="add" @click="cusAdd"
        >Add</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        v-if="btndis2"
        color="success"
        type="filled"
        icon="visibility"
        @click="cusView"
        >View</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="warning"
        type="filled"
        icon="create"
        @click="cusEdit"
        v-if="btndis"
        >Edit</vs-button
      >
      <p class="pr-4"></p>
      <vs-button
        color="danger"
        type="filled"
        icon="remove_circle_outline"
        @click="cusDel"
        v-if="btndis"
        >Delete</vs-button
      >
        <p class="pr-4"></p>
      <vs-button
        type="filled"
        icon="add"
        color="warning"
        v-if="btndis"
        @click="goShipping"
        >Shipping</vs-button
      >
      <!-- <p class="pr-4"></p>
      <vs-button
        color="success"
        type="filled"
        icon="list"
        @click="goDetail"
        v-if="btndis"
        >Exbdetails</vs-button
      > -->
      <p class="pr-4"></p>
      <vs-dropdown>
        <vs-button
          v-if="btndis2"
          class="btn-drop"
          type="filled"
          icon="print"
          color="danger"
          >Document Print</vs-button
        >
        <vs-dropdown-menu>
          <!-- <vs-dropdown-item @click="goMoves"
            >ใบกำกับการขนย้ายสินค้า</vs-dropdown-item
          > -->
          <vs-dropdown-item @click="goPermits">Customs Permit</vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
      <p class="pr-4"></p>

      <!-- <div class="fab-wrapper" :style="fabStyle" v-if="btndis">
        <vs-dropdown vs-trigger-click class="cursor-pointer">
          <div
            class="
              fab
              p-8
              rounded-full
              cursor-pointer
              flex
              items-center
              justify-between
            "
          >
            <feather-icon icon="ChevronUpIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item
              v-for="fab in fabact"
              :key="fab.act"
              @click="handle_function_call(fab.act)"
            >
              <span>{{ fab.label }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div> -->
    </div>

    <transition-group
      enter-active-class="animated lightSpeedIn"
      leave-active-class="animated lightSpeedOut"
    >
      <exbupload
        v-if="comUpload"
        :key="comUpload"
        @done="uploadDone"
      ></exbupload>
      <exbadd
        v-if="addshow"
        key="addshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
      ></exbadd>
      <cpview
        v-if="viewshow"
        key="viewshow"
        :acstate="acstate"
        :recid="recid"
        @grid="grid"
      ></cpview>
      <aggrid
        v-if="gridshow"
        :key="gridshow"
        @recsel="recsel"
        :companyGroupsCode="companyGroupsCode"
        @mousedown.middle.native="getXY"
      ></aggrid>
    </transition-group>

    <vs-popup title="Shipping Name" :active.sync="popupActive4">
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span>ชื่อ</span>
        </div>
        <div class="column is-narrow">
          <div style="width: 350px">
         <vs-select autocomplete v-model="shipname" class="w-full">
            <vs-select-item
              v-for="ltype in ships"
              :key="ltype.code"
              :value="ltype.code"
              :text="ltype.tname"
            />
          </vs-select>
          </div>
        </div>
      </div>
      <div class="columns">
        <div
          class="column is-narrow mt-3"
          style="width: 100px; text-align: right"
        >
          <span></span>
        </div>
        <div class="column is-narrow">
          <div style="width: 250px">
            <vs-button
              color="success"
              type="filled"
              icon="check"
              @click="acceptConfirm4"
              >Submit</vs-button
            >
          </div>
        </div>
      </div>
    </vs-popup>

  </div>
</template>

<script>
// import aggrid from "./DataTable/AgGrid";
import aggrid from "./grid";
import exbadd from "./cpadd.vue";
import cpview from "./cpview.vue";
import exbupload from "./exbupload";

import pdfMake from "pdfmake";
import pdfFonts from "../../../assets/custom-fonts";
import axios from "axios";
import {
  BASE_API_URL,
  PROX_URL,
  NETBAY_URL,
  NETBAY_User,
  NETBAY_Password,
  NETBAY_Companycode,
  ENV_CHECK
} from "@/constants/index.ts";
import JsBarcode from "jsbarcode/bin/JsBarcode";

export default {
  data() {
    return {
      walletId:"",
      shipname:"",
      ships:[],
      businessPartnersCode: "",
      userid: "",
      companyGroupsCode: "",
      arData: [],
      contents: [],
      viewshow: false,
      addshow: false,
      gridshow: false,
      btndis: false,
      btndis2: false,
      comUpload: false,
      popupActive4: false,
      recid: "0",
      curX: null,
      curY: null,
      acstate: null,
      fabact: [
        { act: "cusAdd", label: "Add" },
        { act: "cusEdit", label: "Edit" },
        { act: "cusDel", label: "Delete" },
        { act: "goDetail", label: "Exbdetails" },
        { act: "hideFab", label: "Hide" },
      ],
    };
  },
  computed: {
    fabStyle: function () {
      return {
        left: this.curX + "px",
        top: this.curY + "px",
      };
    },
  },
  methods: {
    goShipping(){
      this.shipname = "";
      this.popupActive4 = true;
    },
    async acceptConfirm4() {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;
        this.popupActive4 = false;

        if (token) {
          const formDataf = {
            number: this.recid,
            shipname: this.shipname,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exbdetails/addShippingDto`,
            formDataf,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });

            this.errdata = response.data.errdata;
            this.errorshow = true;
          } else {
             if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

             this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "๊Update Complete",
              text: response.data.message,
            });
            
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
    },
     textToBase64Barcode(text) {
      var canvas = document.createElement("canvas");
      JsBarcode(canvas, text, { format: "CODE39" });
      return canvas.toDataURL("image/png");
    },
    cvDate(date) {
      let d = new Date(date);
      let dformat =
        [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/") +
        " " +
        [d.getHours(), d.getMinutes(), d.getSeconds()].join(":");
      return dformat;
    },
    cvDateNoTime(date) {
      let d = new Date(date);
      let dformat = [d.getDate(), d.getMonth() + 1, d.getFullYear()].join("/");
      return dformat;
    },
    handle_function_call(function_name) {
      this[function_name]();
    },
    uploadDone() {
      // alert("Done");
      this.comUpload = false;

      this.gridshow = true;
    },
    upload() {
      this.comUpload = true;
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
    },
    recsel(val, val2) {
      // console.log(val);
      this.btndis2 = true;
      if (val2 == "WAIT") {
        this.btndis = true;
      } else {
        this.btndis = false;
      }
      this.recid = val;
    },
    goDetail() {
      localStorage.setItem("LS_Page", this.$route.path);
      this.btndis = true;
      this.$router.replace("/cpermitdetails/" + this.recid);
    },
    conCMAN() {
      // console.log(this.recid);
      // this.$router.replace("/CMAN" );
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Convert? " + this.recid,
        accept: this.acceptCMAN,
      });
    },
    acceptCMAN() {
      this.btndis = false;
      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        number: this.recid,
      };
      axios
        .post("/ApiConvertToCmans", formData)
        .then((response) => {
          if (response.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Convert Error",
              text: response.data.message,
            });
          } else {
            this.$store.dispatch("setReportGrid", 1);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Convert Complete",
              text: response.data.message,
            });
            this.$router.replace("/CMAN");
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Deleted Error",
            text: err,
          });
        });

      // this.gridshow = false;
      // this.gridshow = true;
    },
    cusAdd() {
      // console.log('cusAdd')
      this.comUpload = false;
      this.recid = 0;
      this.addshow = true;
      this.gridshow = false;
      this.viewshow = false;
      this.btndis = false;
      this.acstate = "ADD";
    },
    grid() {
      // console.log(this.$store.state.reportgrid)
      this.viewshow = false;
      this.comUpload = false;
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
      setTimeout(() => {
        this.gridshow = true;
      }, 300);
      // this.$store.dispatch("setReportGrid", 0);
    },
    cusView() {
      this.btndis = true;
      this.viewshow = true;
      this.addshow = false;
      this.gridshow = false;
      this.btndis = false;
      this.errorshow = false;
      this.acstate = "EDIT";
    },
    cusEdit() {
      this.viewshow = false;
      this.comUpload = false;
      this.addshow = true;
      this.gridshow = false;
      this.btndis = false;
      this.acstate = "EDIT";
    },
    cusDel() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Delete? " + this.recid,
        accept: this.acceptAlert,
      });
    },
    async acceptAlert() {
      // console.log(this.$store.state.reportgrid)

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exborders/delete`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            if (this.$store.state.reportgrid == 0) {
              this.$store.dispatch("setReportGrid", 1);
            } else {
              this.$store.dispatch("setReportGrid", 0);
            }

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Deleted Complete",
              text: response.data.message,
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    cusDel2() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm`,
        text: "Do you want to Cancel? " + this.recid,
        accept: this.acceptAlert2,
      });
    },
    acceptAlert2() {
      this.btndis = false;

      const formData = {
        token: localStorage.getItem("token"),
        dbname: localStorage.getItem("dbname"),
        number: this.recid,
      };

      // console.log(this.recid);
      axios
        .post("/ApiCancelExborders", formData)
        .then((response) => {
          if (response.data.status == "error") {
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Cancel Error",
              text: response.data.message,
            });
          } else {
            this.$store.dispatch("setReportGrid", 1);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Cancel Complete",
              text: response.data.message,
            });
          }
        })
        .catch((err) => {
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Cancel Error",
            text: err,
          });
        });
    },
    async goMoves() {
      this.goDate();

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exborders/printDOMOut`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            this.getArray(response.data.message);

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              content: [
                {
                  text: "แนบท้ายประกาศกรมศุลกากรที่ /2564",
                  fontSize: 15,
                  alignment: "right",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 10],
                },
                {
                  text: "ใบกำกับการขนย้ายสินค้า",
                  style: "title",
                },
                {
                  text: "หมายเลขอ้างอิง.................................................................เลขที่ใบกำกับการขนย้ายสินค้า........................................................................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 20, 0, 0],
                },
                {
                  text: "ข้าพเจ้า ......................................................................เลขประจำตัวผู้เสียภาษีอากร..................................................................................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "สำนักงาน ตั้งอยู่เลขที่........................................หมู่ที่............................อาคาร....................................................ชั้นที่.........................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "ตรอก/ซอย..............................ถนน............................ตำบล/แขวง......................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "อำเภอ/เขต.............................จังหวัด............................รหัสไปรษณีย์..............โทรศัพท์..................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "ผู้รับผิดชอบการบรรจุ ขอรับรองว่าสินค้าตามใบขนสินค้าขาออก/ผ่านแดน ข้างล่างนี้ ได้บรรจุเข้า",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 20],
                },
                {
                  columns: [
                    {
                      width: 30,
                      canvas: [
                        {
                          type: "polyline",
                          lineWidth: 1,
                          closePath: true,
                          points: [
                            { x: 0, y: 0 },
                            { x: 20, y: 0 },
                            { x: 20, y: 20 },
                            { x: 0, y: 20 },
                          ],
                        },
                      ],
                      margin: [30, 0, 0, 0],
                    },
                    {
                      text: "คอนเทนเนอร์ชนิด........................เลขหมายตู้คอนเทนเนอร์...........................",
                      fontSize: 15,
                      alignment: "left",
                      // [left, top, right, bottom]
                      // margin: [100, -20, 0, 0],
                      margin: [30, 0, 0, 20],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      width: 30,
                      canvas: [
                        {
                          type: "polyline",
                          lineWidth: 1,
                          closePath: true,
                          points: [
                            { x: 0, y: 0 },
                            { x: 20, y: 0 },
                            { x: 20, y: 20 },
                            { x: 0, y: 20 },
                          ],
                        },
                      ],
                      margin: [30, 0, 0, 0],
                    },
                    {
                      text: "รถยนต์ประเภท..........................เลขทะเบียนพ่วง.............................จังหวัด..........................",
                      fontSize: 15,
                      alignment: "left",
                      // [left, top, right, bottom]
                      // margin: [100, -20, 0, 0],
                      margin: [30, 0, 0, 5],
                    },
                  ],
                },
                {
                  text: "เลขทะเบียนพ่วง..................................................................จังหวัด..........................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [60, 0, 0, 20],
                },
                {
                  text: "ถูกต้องครบถ้วนเพื่อส่งออกทาง (ท่า/ที่/สำนักงานศุลกากร/ด่านศุลกากร)...........................................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "โดยยานพาหนะ............................................เที่ยวเรือ/บิน.........................................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "ท่าขนถ่ายสินค้า............................................วันที่ส่งออก.........................................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 10],
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [50, 100, 140, 100, 100], // 525
                    body: [
                      [
                        {
                          text: "ลำดับ",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                        {
                          text: "เลขที่ใบขนสินค้า" + "\n" + "(ขาออก/ผ่านแดน)",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                        {
                          text: "ชื่อผู้ส่งออก/ผู้ขอผ่านแดน",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                        {
                          text: "จำนวนหีบห่อ",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                        {
                          text: "น้ำหนักรวม",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [50, 100, 140, 100, 100], // 525
                    body: this.arData,
                    // body: [[{}, {}, {}, {}, {}]],
                  },
                },
                {
                  table: {
                    heights: 15,
                    widths: [50, 100, 140, 100, 100], // 525
                    body: [
                      [
                        {
                          colSpan: 3,
                          text: "รวม",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                        {},
                        {},
                        {},
                        {},
                      ],
                    ],
                  },
                },
                {
                  text: "ลายมือชื่อผู้รับผิดชอบการบรรจุ",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [250, 20, 0, 25],
                },
                {
                  text: "วันที่ยื่น ............................................",
                  fontSize: 15,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [250, 0, 0, 5],
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }
      // this.gridshow = false;
      // this.gridshow = true;
    },
    async goPermits() {
      this.contents = [];

      this.goDate();

      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));
        this.readonly = true;

        if (token) {
          const formData = {
            number: this.recid,
            editor: String(this.userid),
            companyGroupsCode: this.companyGroupsCode,
          };

          const response = await axios.post(
            `${BASE_API_URL}/outbound-svc/exborders/printExbordersPermit`,
            formData,
            {
              headers: { Authorization: "Bearer " + token.accessToken },
            }
          );
          // console.log(response.data);

          if (response.data.status != "success") {
            this.loading = false;
            this.$vs.notify({
              position: "top-right",
              color: "danger",
              title: "Error from Backend",
              text: response.data.message,
            });
          } else {
            this.getArrayPermit(response.data.sumd);

            let cnname, cnnamea, cnsubp, cnprov;

            response.data.cmandetail[0].cnname == null ||
            response.data.cmandetail[0].cnname == ""
              ? (cnname = "-")
              : (cnname = response.data.cmandetail[0].cnname);

            response.data.cmandetail[0].cnnamea == null ||
            response.data.cmandetail[0].cnnamea == ""
              ? (cnnamea = "-")
              : (cnnamea = response.data.cmandetail[0].cnnamea);

            response.data.cmandetail[0].cnsubp == null ||
            response.data.cmandetail[0].cnsubp == ""
              ? (cnsubp = "-")
              : (cnsubp = response.data.cmandetail[0].cnsubp);

            response.data.cmandetail[0].cnprov == null ||
            response.data.cmandetail[0].cnprov == ""
              ? (cnprov = "-")
              : (cnprov = response.data.cmandetail[0].cnprov);

            const docDefinition = {
              // a string or { width: number, height: number }
              pageSize: "A4",

              // by default we use portrait, you can change it to landscape if you wish
              pageOrientation: "portrait",
              content: [
                {
                  text: "BANGKOK, THAILAND.",
                  style: "title",
                },
                {
                  text: "Customs Permit",
                  style: "title",
                },
                {
                  text: "Bangkok Airport",
                  style: "title",
                  margin: [0, 0, 0, 20],
                },
                              {
                image: this.textToBase64Barcode(response.data.message[0].dclnumber),
                width: 150,
                height: 40,
                absolutePosition: { x: 400, y: 50 },
              },
                {
                  table: {
                    widths: [300, 200],
                    body: [
                      [
                        {
                          border: [false, false, false, false],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text:
                            "Registration No..........." +
                            response.data.message[0].dclnumber +
                            "............",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: "Consignee name & address..................",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text: "Carrier's D/O No....................................................",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: cnname,
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text:
                            "Aircraft................" +
                            response.data.message[0].vesselname +
                            ".......................",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: cnnamea,
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          margin: [0, 0, 30, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text:
                            "Number.............." +
                            this.recid +
                            "................",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                      [
                        {
                          border: [false, false, false, false],

                          text: cnsubp,
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text:
                            "Date of Arrival..........." +
                            this.cvDateNoTime(response.data.arrival) +
                            "......................",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: cnprov,
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text:
                            "Air Way Bill No............" +
                            response.data.message[0].mawb +
                            ".............",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                      [
                        {
                          border: [false, false, false, false],
                          text: "",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                        {
                          border: [false, false, false, false],
                          text:
                            "HAWB No............" +
                            response.data.hawb +
                            ".............",
                          fontSize: 12,
                          alignment: "left",
                          // [left, top, right, bottom]
                          // margin: [100, -20, 0, 0],
                        },
                      ],
                    ],
                  },
                },
                {
                  text: "I hereby certified my ture possesion of the cargo detailed below and I am in full legal responsibility ",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [50, 20, 0, 0],
                },
                {
                  text: "pertaining to customs law and regulations concerned after remove from the approved godown prior to the customs",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 0],
                },
                {
                  text: "clearances",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 5],
                },
                {
                  text: "(Signature)____________________________________________________Consignee or Agent",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [120, 0, 0, 0],
                },
                {
                  text: "(BLOCK LETTER)",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [250, 0, 0, 5],
                },
                {
                  text: "Allowed to remove the packages as described below from customs approved godown",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [50, 0, 0, 5],
                },
                {
                  text: "No.___________________________pending Customs examiniation.",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 10],
                },
                {
                  text: "(Signature)____________________________________________________Inspector-In-charge.",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [120, 0, 0, 10],
                },
                {
                  table: {
                    // headers are automatically repeated if the table spans over multiple pages
                    // you can declare how many rows should be treated as headers
                    headerRows: 1,
                    widths: [100, 100, 200, 80], // 525
                    body: [
                      [
                        {
                          text: "Marks & Number",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                        {
                          text: "Nos. & Description" + "\n" + "of Packages",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                        {
                          text: "Pariculars of goods",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                        {
                          text: "Remarks",
                          bold: true,
                          fontSize: 12,
                          alignment: "center",
                        },
                      ],
                    ],
                  },
                },
                {
                  table: {
                    heights: 50,
                    widths: [100, 100, 200, 80], // 525
                    // body: this.getArray(response.data.message[il]),
                    // body: [[{}, {}, {}, {}]],
                    body: this.arData,
                  },
                },
                {
                  text: "All the packages described above have removed from customs approved godown",
                  fontSize: 12,
                  alignment: "center",
                  // [left, top, right, bottom]
                  margin: [0, 10, 0, 5],
                },
                {
                  text: "No._______________________________________",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 5],
                },
                {
                  text: "(Signature)____________________________________________________Godown Keeper.",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [120, 0, 0, 5],
                },
                {
                  text: "Packages of cargo described above (Entry No.______________________________________________) have been duly",
                  fontSize: 12,
                  alignment: "center",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                },
                {
                  text: "cleared, Permission is hereby granted to pass through the Customs Checking Post",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [0, 0, 0, 5],
                },
                {
                  text: "(Signature)____________________________________________________Godown Keeper.",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [120, 0, 0, 5],
                },
                {
                  text: "(Signature)____________________________________________________Inspector.",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [120, 0, 0, 5],
                },
                {
                  text: "Packages bearing description there of on the above mentioned, checked and found correct, released.",
                  fontSize: 12,
                  alignment: "center",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                },
                {
                  text: "(Signature)____________________________________________________Checking Post Officer.",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [120, 0, 0, 0],
                },
                {
                  text: "Date _____________/______________/______________",
                  fontSize: 12,
                  alignment: "left",
                  // [left, top, right, bottom]
                  // margin: [100, -20, 0, 0],
                  margin: [140, 0, 0, 0],
                },
              ],
              defaultStyle: {
                // 4. default style 'THSarabunNew' font to test
                font: "THSarabunNew",
              },
              styles: {
                title: {
                  fontSize: 20,
                  bold: true,
                  alignment: "center",
                },
                header: {
                  fontSize: 18,
                  bold: true,
                  alignment: "right",
                  margin: [0, 190, 0, 80],
                },
                subheader: {
                  fontSize: 14,
                },
                superMargin: {
                  margin: [20, 0, 40, 0],
                  fontSize: 15,
                },
              },
            };

            pdfMake.vfs = pdfFonts.pdfMake.vfs; // 2. set vfs pdf font
            pdfMake.fonts = {
              // default Roboto font
              Roboto: {
                normal: "Roboto-Regular.ttf",
                bold: "Roboto-Medium.ttf",
                italics: "Roboto-Italic.ttf",
                bolditalics: "Roboto-MediumItalic.ttf",
              },
              // THSarabunNew Font
              THSarabunNew: {
                normal: "THSarabunNew.ttf",
                bold: "THSarabunNew Bold.ttf",
                italics: "THSarabunNew italic.ttf",
                bolditalics: "THSarabunNew Bolditalic.ttf",
              },
            };

            setTimeout(() => {
              pdfMake.createPdf(docDefinition).open();
            }, 1000);

            this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Print Complete",
              text: "Print Complete",
            });

            if (ENV_CHECK == "PROD") {
              this.submitFDMS(this.recid);
            }
          }
        }
      } catch (error) {
        this.data = [];
        this.total = 0;
        this.loading = false;
        // throw error;
        alert("กรุณาเข้าระบบอีกครั้ง");
        // this.$router.replace("/pages/login/");
      }

      // this.gridshow = false;
      // this.gridshow = true;
    },
    async submitFDMS(ReferenceNumber) {
      try {
        const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

        const formData2 = {
          number: ReferenceNumber,
          editor:String(this.userid)
        };

        const response2 = await axios.post(
          `${BASE_API_URL}/outbound-svc/cpermits/normalPermitToFDMS`,
          formData2,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (response2.data.status != "success") {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error from Submit to FDMS",
            text: response2.data.message,
          });
        } 
        else {
           this.$vs.notify({
              position: "top-right",
              color: "success",
              title: "Success",
              text: response2.data.message,
            });
        }
      } catch (error) {
        alert("กรุณาเข้าระบบอีกครั้ง");
      }
    },
    // async submitFDMS(ReferenceNumber) {
    //   try {
    //     const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

    //     const formData2 = {
    //       number: ReferenceNumber,
    //     };

    //     const response2 = await axios.post(
    //       `${BASE_API_URL}/outbound-svc/cpermits/normalPermitToFDMS`,
    //       formData2,
    //       {
    //         headers: { Authorization: "Bearer " + token.accessToken },
    //       }
    //     );

    //     if (response2.data.status != "success") {
    //       this.loading = false;
    //       this.$vs.notify({
    //         position: "top-right",
    //         color: "danger",
    //         title: "Error from Submit to FDMS",
    //         text: response2.data.message,
    //         fixed: true,
    //       });
    //     } else {
    //       const NETBAY_TOKEN = localStorage.getItem("NETBAY_TOKEN");
    //       //  console.log(NETBAY_TOKEN);
    //       try {
    //         // console.log('netlogin');
    //         const formData3 = {
    //           transactionNo: response2.data.message.transactionNo,
    //           declarationNo: response2.data.message.declarationNo,
    //           documentType: response2.data.message.documentType,
    //           receivedControlNo: response2.data.message.receivedControlNo,
    //           callsign: response2.data.message.callsign,
    //           voyage: response2.data.message.voyage,
    //           portOfDischarge: response2.data.message.portOfDischarge,
    //           shedNo: response2.data.message.shedNo,
    //           vesselName: response2.data.message.vesselName,
    //           masterBL: response2.data.message.masterBL,
    //           houseBL: response2.data.message.houseBL,
    //           arrivalDate: response2.data.message.arrivalDate,
    //           consigneeName: response2.data.message.consigneeName,
    //           mark: response2.data.message.mark,
    //           noOfPackage: response2.data.message.noOfPackage,
    //           packageUnit: response2.data.message.packageUnit,
    //           gossWeight: response2.data.message.gossWeight,
    //           weightUnit: response2.data.message.weightUnit,
    //           clearanceDate: response2.data.message.clearanceDate,
    //           clearanceTime: response2.data.message.clearanceTime,
    //           transmitDate: response2.data.message.transmitDate,
    //           transmitTime: response2.data.message.transmitTime,
    //           containerNoArray: response2.data.message.containerNoArray,
    //           noOfContainer: response2.data.message.noOfContainer,
    //         };

    //         const response3 = await axios.post(
    //           PROX_URL + NETBAY_URL + `fz-webservice/api/receive-permit-normal`,
    //           // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
    //           // `https://uataotdc.netbay.co.th/fz-webservice/api/zone3-otherport`,
    //           // `/api/fz-webservice/api/zone3-otherport`,
    //           formData3,

    //           {
    //             headers: {
    //               "Content-Type": "application/json",
    //               token: NETBAY_TOKEN,
    //             },
    //           }
    //         );

    //         if (response3.status == "fail") {
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "danger",
    //             title: "Error",
    //             text: response3.message,
    //           });
    //         } else {
    //           this.$vs.notify({
    //             position: "top-right",
    //             color: "success",
    //             title: "Submit Success",
    //             text: response3.data.message,
    //           });

    //           const moment = require("moment-timezone");
    //           const timezone = "Asia/Bangkok";
    //           const now = moment().tz(timezone);

    //           const formData = {
    //             number: ReferenceNumber,
    //             code: response3.data.code,
    //             message: response3.data.message,
    //             createdAt: now,
    //           };

    //           await axios.post(
    //             `${BASE_API_URL}/outbound-svc/exborders/resFDMSOut`,
    //             formData,
    //             {
    //               headers: { Authorization: "Bearer " + token.accessToken },
    //             }
    //           );
    //         }
    //       } catch (error) {
    //         // alert("กรุณาเข้าระบบอีกครั้ง");
    //         if (error.response) {
    //           // console.log(error.response.data);
    //           // console.log(error.response.data.message);
    //           // console.log(error.response.status);
    //           // console.log(error.response.headers);
    //           if (error.response.data.message == "Token has expired.") {
    //             this.$vs.notify({
    //               position: "top-right",
    //               color: "danger",
    //               title: "Error",
    //               text: error.response.data.message,
    //             });
    //           } else {
    //             this.$vs.notify({
    //               position: "top-right",
    //               color: "danger",
    //               title: "Error",
    //               text: error.response.data.message,
    //             });

    //             const moment = require("moment-timezone");
    //             const timezone = "Asia/Bangkok";
    //             const now = moment().tz(timezone);

    //             const formData = {
    //               number: ReferenceNumber,
    //               code: error.response.data.code,
    //               message: error.response.data.message,
    //               createdAt: now,
    //             };

    //             await axios.post(
    //               `${BASE_API_URL}/outbound-svc/exborders/resFDMSOut`,
    //               formData,
    //               {
    //                 headers: { Authorization: "Bearer " + token.accessToken },
    //               }
    //             );
    //           }
    //         }
    //       }
    //     }
    //   } catch (error) {
    //     alert("กรุณาเข้าระบบอีกครั้ง");
    //   }
    // },
    getArray(data) {
      // console.log(val);
      this.arData = [];

      let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: i,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: item.dclnumber,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          {
            text: item.importer,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text: this.formatnumber(item.itempck) + " " + item.packagesCode,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
          {
            text: this.formatnumber(item.itemgw) + " " + item.gwunit,
            fontSize: 10,
            bold: true,
            alignment: "right",
          },
        ]);
      });
    },
    getArrayPermit(data) {
      // console.log(data);
      this.arData = [];

      // let i = 1;

      data.forEach((item) => {
        // item.updated_at = item.updated_at
        //   ? item.updated_at.replace(/-/g, "/")
        //   : null;
        this.arData.push([
          {
            text: item.remark,
            fontSize: 10,
            bold: true,
            alignment: "center",
          },
          [
            {
              text: this.formatnumber(item.itempck) + " " + item.packagesCode,
              fontSize: 10,
              bold: true,
              alignment: "right",
            },
            {
              text: this.formatnumber(item.itemgw) + " " + item.gwunit,
              fontSize: 10,
              bold: true,
              alignment: "right",
            },
          ],

          {
            text: item.edescription,
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          {
            text: "",
            fontSize: 10,
            bold: true,
            alignment: "left",
          },
          // {
          //   text: this.formatnumber(item.itemgw) + " " + item.gwunit,
          //   fontSize: 10,
          //   bold: true,
          //   alignment: "right",
          // },
        ]);

        // i++;
        // console.log(i);
      });
    },
    goDate() {
      let today = new Date();
      let dd = today.getDate();

      let mm = today.getMonth() + 1;
      let yyyy = today.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }

      if (mm < 10) {
        mm = "0" + mm;
      }
      this.daday = dd;
      this.damonth = mm;
      this.dayear = Number(yyyy) + 543;
      this.dtoday = dd + "-" + mm + "-" + yyyy;
    },
    formatnumber(number) {
      return number.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    getXY(event) {
      this.curX = event.clientX;
      this.curY = event.clientY;

      // console.log(this.curX);
      // console.log(this.curY);
    },
    hideFab() {
      this.btndis = false;
    },
        async fdmsLogin() {
      try {
        const formData2 = {
          username: NETBAY_User,
          password: NETBAY_Password,
          companyCode: NETBAY_Companycode,
        };

        const response2 = await axios.post(
          PROX_URL + NETBAY_URL + `fz-webservice/api/auth`,
          // `https://kongapi.aotga.com/proxy-svc/https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `https://uataotdc.netbay.co.th/fz-webservice/api/auth`,
          // `/api/fz-webservice/api/auth`,
          formData2,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        // console.log(response2.data.data);
        if (response2.data) {
          localStorage.setItem("NETBAY_TOKEN", response2.data.data);
        }
      } catch (error) {
        // alert("กรุณาเข้าระบบอีกครั้ง");
        if (error.response) {
          // console.log(error.response.data);
          // console.log(error.response.data.message);
          // console.log(error.response.status);
          // console.log(error.response.headers);
          this.$vs.notify({
            position: "top-right",
            color: "danger",
            title: "Error",
            text: error.response.data.message,
          });
        }
      }
    },
    async checkProfiles() {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      if (token) {
        const decoded = JSON.parse(
          Buffer.from(token.accessToken.split(".")[1], "base64").toString()
        );

        // console.log(decoded);

        try {
          // console.log(responseponse.data);
          this.userid = decoded.userId;
          this.userRole = decoded.userRole;

          this.businessPartnersCode = decoded.businessPartnersCode;
          this.companyGroupsCode = decoded.companyGroupsCode;
          this.walletId = decoded.walletId;
        } catch (error) {
          alert("กรุณาเข้าระบบอีกครั้ง");
          await this.$router.replace("/");
        }
      } else {
        alert("กรุณาเข้าระบบอีกครั้ง");
        await this.$router.replace("/");
      }
    },
  },
  async beforeCreate() {
    try {
      const token = JSON.parse(localStorage.getItem("KK_AUTH_TOKEN"));

      this.loading = true;

      if (token) {
        const formData = {
          searchval: "",
        };

        const response = await axios.post(
          `${BASE_API_URL}/outbound-svc/businesspartners/getShipping`,
          formData,
          {
            headers: { Authorization: "Bearer " + token.accessToken },
          }
        );

        if (!response.data) {
          this.loading = false;
          this.$vs.notify({
            position: "top-right",
            // color: "danger",
            title: "Error from Backend",
            text: response.data,
          });
        } else {
          this.loading = false;
          // console.log(response.data)
          this.ships = response.data;
        }
      }
    } catch (error) {
      this.loading = false;
      // throw error;
      alert("กรุณาเข้าระบบอีกครั้ง");
      // await this.$router.replace("/pages/login/");
    }
  },
  mounted() {
    this.checkProfiles();
    // console.log(this.$acl.check('admin'));
    // console.log(this.$store.state.reportgrid)
    // this.fdmsLogin();
  },
  components: {
    aggrid,
    exbupload,
    exbadd,
    cpview,
  },
};
</script>

<style scoped>
.fab-wrapper {
  position: fixed;
  left: 100px;
  top: 500px;
  z-index: 5;
  display: flex;
  flex-direction: center;
  align-items: center;
}
.fab {
  background-color: rgb(231, 55, 55);
}
</style>
